module.exports = __webpack_public_path__ + "static/media/sophia_et_veronique_.a9ac76d8.jpg";